'use strict';

import _ from 'lodash';

export default (value, codeList) => {
  return !!value ? _.find(codeList, {value: value}).label : null;
}



// WEBPACK FOOTER //
// ./client/filters/codeListValueFilter.js